<template>
	<div v-parallax-fit="parallax" class="slide-pickets">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/08_pickets.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 17500,
						end: 19000,
						fromStyle: { transform: 'translateY(100%) scale(1)' },
           				toStyle: { transform: 'translateY(-130%) scale(1.4)' },
						easing: 'linear'
					},
					{
						start: 19000,
						end: 25000,
						fromStyle: { transform: 'translateY(-130%) scale(1.4)' },
           				toStyle: { transform: 'translateY(-40%) scale(1.4)' },
						easing: 'linear'
					},
					{
						start: 25000,
						end: 26000,
						fromStyle: { transform: 'translateY(-40%) scale(1.4)' },
           				toStyle: { transform: 'translateY(150%) scale(1.1)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-pickets {
		position: absolute;
	    top: 150%;
	    left: 0%;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 650px) {
		.slide-pickets {
			top: 200%;
		}
	}
</style>
